import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { MichiganCornholeMultiplierAnimation } from './mi-cornhole-multiplier-animiation'

export const MI_MULTIPLIER_CORNHOLE_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: MichiganCornholeMultiplierAnimation,
}
